import * as aor from "react-admin";
import React from "react";
import CreateUserForm from "../../components/CreateUserForm";

export default props => (
    <aor.Create {...props}>
        <CreateUserForm {...props} />
    </aor.Create>
);



// WEBPACK FOOTER //
// ./src/resources/Users/Create.js